import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    HorseInfoWrapper,
    RaceBoxWrapper,
} from 'src/domains/sportsbook/webview/components/raceBoxSelection/RaceBoxSelectionLoader.style';
import {
    EventsLoader,
    FirstLineRacingLoader,
    SecondLineRacingLoader,
    SelectionLoader,
    SilkLoader,
} from 'src/domains/layouts/shared/loaders';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

export const RaceBoxSelectionLoader = observer('RaceBoxSelectionLoader', () => {
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    const { raceCardVariant, selectionVariant } = configState.componentVariants;
    return (
        <RaceBoxWrapper variant={raceCardVariant}>
            <HorseInfoWrapper variant={raceCardVariant}>
                <SilkLoader />

                <EventsLoader>
                    <FirstLineRacingLoader />
                    <SecondLineRacingLoader />
                </EventsLoader>
            </HorseInfoWrapper>

            <SelectionLoader variant={selectionVariant} />
        </RaceBoxWrapper>
    );
});
